<h2
  [class.mb-5]="isExpanded()"
  class="text-2xl font-bold flex justify-between items-center w-full text-grey-0 gap-6"
>
  <span>Stämmer inte informationen?</span>

  <app-ui-icon
    (click)="toggleExpand()"
    [name]="isExpanded() ? 'chevron_collapse' : 'chevron_expand'"
    color="#202225"
  ></app-ui-icon>
</h2>

@if (isExpanded()) {
  <div class="text-base">
    <div [innerHTML]="content" class="description"></div>
    <app-ui-button
      (click)="openModal()"
      color="green"
      size="md"
      title="Jag vill synas på Vården.se"
    >
      Uppge felaktig information
    </app-ui-button>
  </div>
}

